








import { Component, Vue } from 'vue-property-decorator'
import OutdoorDisplay from '@/components/outdoor/OutdoorDisplay.vue'
import OutdoorDisplayMobile from '@/components/outdoor/OutdoorDisplayMobile.vue'

@Component({
  components: {
    OutdoorDisplay,
    OutdoorDisplayMobile,
  },
})
export default class Outdoor extends Vue {}
